import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {PromotionModel} from '../../../../core-logic/models/promotion/promotion-model';
import moment from 'moment/moment';
import {NavigationExtras, Router} from '@angular/router';
import {Camera, CameraResultType, CameraSource} from '@capacitor/camera';
import {dataURItoBlob, getFileReader} from '../../../../common/functions/utilities-functions';
import {ToastService} from '../../../../common/services/toast-service';
import {ActionSheetController} from '@ionic/angular';
import {PromotionGatewayHttp} from '../../../../adapters/real/api-services/gateways/promotion-gateway-http';
import {StorageBusinessesManagerService} from '../../../../common/services/storage-businesses-manager.service';
import {first} from 'rxjs/operators';
import _ from 'lodash';
import {AddressModel} from '../../../../core-logic/models/address/address-model';

@Component({
  selector: 'app-promotion',
  templateUrl: './promotion.component.html',
  styleUrls: ['./promotion.component.scss'],
})
export class PromotionComponent implements OnChanges {
  @Input() isSuspended = false;
  @Input() businessViewMode = true;
  @Input() previewMode = false;
  @Input() style: any = {width: '90%', margin: '0 auto 0.6rem'};
  @Input() manageMode = false;
  @Input() promotion: PromotionModel;
  @Input() pictureUrl: string = '';
  @Input() route: { commands: any[]; extras?: NavigationExtras } = {commands: []};
  @Input() statisticsRoute: { commands: any[]; extras?: NavigationExtras } = {commands: []};
  @Input() showFooterButtons: boolean = false;
  @Output() initializedPictureUri = new EventEmitter<string>();
  private imgMaxSize: number = 10485760; // 10M
  private readonly mimeTypes: string [] = ['image/jpeg', 'image/jpg', 'image/png'];
  promotionAddresses: AddressModel [];
  constructor(
    private router: Router,
    private toastService: ToastService,
    private changeDetector: ChangeDetectorRef,
    private actionSheetController: ActionSheetController,
    private promotionGatewayHttp: PromotionGatewayHttp,
    private storageBusinessesManagerService: StorageBusinessesManagerService
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.promotion && this.promotion) {
      if (this.businessViewMode) {
        this.storageBusinessesManagerService.getBusinessesSubject$()
          .pipe(first())
          .subscribe(businesses => {
            const business = businesses.find(wantedBusiness => wantedBusiness._id === this.promotion.business);
            this.promotionAddresses = business.addresses.filter(address => this.promotion.addresses.includes(address._id));
          });
      }
    }
    if (changes.promotion && this.promotion && this.promotion.content && this.promotion.content.picture && !this.pictureUrl) {
      this.promotionGatewayHttp.getPromotionPicture(this.promotion.content.picture).subscribe(promotionPicture => {
        if (promotionPicture) {
          this.imageBlobToDataURI(promotionPicture);
        } else {
          this.pictureUrl = this.getContextualDefaultImg();
        }
      });
    } else {
      this.pictureUrl = this.getContextualDefaultImg();
    }
  }

  displayFormattedDate() : string {
    const startDate = this.promotion?.content?.start_date;
    const endDate = this.promotion?.content?.end_date;
    return startDate && endDate ?
      `Du ${moment(startDate).format('D MMM à HH:mm')} - Au ${moment(endDate).format('D MMM à HH:mm')}` : '';
  }

  goToRoute() {
    this.router.navigate(this.route.commands, this.route.extras ?? {state: this.promotion});
  }


  async presentActionSheet() {
    if (this.manageMode) {
      const buttons = [{
        text: 'Importer une photo',
        handler: () => this.getLogoFromPhotoLibrary(),
      },
        {
          text: 'Annuler',
          role: 'cancel',
          handler: () => {}
        }
      ];

      if (this.pictureUrl) {
        buttons.push({
          text: 'Supprimer la photo',
          role: '',
          handler: () => {
            this.pictureUrl = '';
            this.initializedPictureUri.emit('');
          },
        });
      }

      const logoActionSheet = await this.actionSheetController.create({
        header: 'Gestionnaire de photos',
        buttons
      });

      await logoActionSheet.present();
    }
  }

  async getLogoFromPhotoLibrary() {
    const cameraPhoto = await Camera.getPhoto({
      quality: 100,
      allowEditing: false,
      source: CameraSource.Photos,
      resultType: CameraResultType.DataUrl,
    });
    const imageDataURI = cameraPhoto.dataUrl;
    const imageBlob = dataURItoBlob(imageDataURI);
    if (imageBlob.size > this.imgMaxSize) {
      await this.toastService.presentErrorMessage('La photo ne doit pas dépasser 1.5M');
    } else if (!this.mimeTypes.includes(imageBlob.type)) {
      await this.toastService.presentErrorMessage('La photo doit être au format JPEG ou JPG ou PNG');
    } else {
      this.pictureUrl = imageDataURI;
      this.initializedPictureUri.emit(this.pictureUrl);
    }
  }

  private imageBlobToDataURI(imageBlob: Blob) {
    const reader = getFileReader();
    reader.onloadend = () => {
      this.pictureUrl = reader.result as string;
      this.changeDetector.detectChanges();
    };
    reader.readAsDataURL(imageBlob);
  }

  private getContextualDefaultImg() {
    return this.pictureUrl ?? '';
  }

  showBanner() {
    return !_.isEmpty(this.pictureUrl);
  }

  goToStatisticPage() {
    this.router.navigate(this.statisticsRoute.commands, this.statisticsRoute.extras ?? {state: {promotion: this.promotion, picture: this.pictureUrl}});
  }

  enableDisablePromotion() {
    this.promotionGatewayHttp.enableDisablePromotionById(this.promotion._id).subscribe(result => {
      console.log(result);
    });
  }
}
